import type { Headline } from "@/widget-components/newsquawk-headlines/models/Headline";

/**
 * Determines if a headline should be hidden from reader-facing feeds.
 *
 * Applied to both transports: headlines arriving live over SSE/polling and
 * those arriving in a REST page. Keeping the two in step matters — filtering
 * only the live path meant a hidden headline vanished for anyone with the
 * widget already open, then reappeared for everyone on the next fetch,
 * pagination or reconnect refetch.
 *
 * Not applied to the editor's single-headline lookup (`useHeadlineById`),
 * which has to be able to load a hidden headline in order to unhide it.
 */
export const shouldHideHeadline = (headline: Headline): boolean => {
  // Hidden flag explicitly set
  if (headline.hidden) {
    return true;
  }

  // Capital-only headlines (appears_on_capital flag)
  if (headline.appears_on_capital) {
    return true;
  }

  return false;
};

/** Drops any headline that `shouldHideHeadline` rejects. */
export const filterVisibleHeadlines = (headlines: Headline[]): Headline[] =>
  headlines.filter((headline) => !shouldHideHeadline(headline));
